/* eslint-disable no-script-url */

import React from 'react';
import Link from '@material-ui/core/Link';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import { postAddCtaToTercero } from '../../actions/postAddCtaToTercero';

import Button from '@material-ui/core/Button';

import clsx from 'clsx';
import Icon from '@material-ui/core/Icon';

import { store } from '../../store';
import { resetCuenta, resetTerceroCuentas } from '../../actions'

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';

import { connect } from 'react-redux';

// Generate Order Data
function createData(resp, facturaNo, cuenta, doc, nombre, telefono, correo, saldo) {
  return { resp, facturaNo, cuenta, doc, nombre, telefono, correo, saldo };
}

const btnAgregar = (cta, props) => {
  //alert("vuamos con :" + cta + "u:" + props.terceroID);

  var post = {
    cuentaCodigo: cta,
    terceroID: props.terceroID
  }

  var formBody = [];

  for (var property in post) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(post[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");

  store.dispatch(resetCuenta());

  store.dispatch(resetTerceroCuentas());
  const info = props.postAddCtaToTercero(formBody);

  return info;
};


const tabla = props => {

  const { classes } = props

  const saldo = Intl.NumberFormat('es-CO',
    { style: 'currency', currency: 'COP' }
  ).format(props.cuenta.saldo);


  const rows = [
    createData(props.cuenta.resp, props.cuenta.facturaNo, props.cuenta.cuenta, props.cuenta.doc, props.cuenta.nombre, props.cuenta.telefono, props.cuenta.correo, saldo),
    // createData(1, '16 Mar, 2019', 'Paul McCartney', 'London, UK', 'VISA ⠀•••• 2574', 866.99),
  ];

  return (
    <Paper className={classes.paper}>

      <React.Fragment>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Cuenta</TableCell>
              <TableCell>Ult. Fact.</TableCell>
              <TableCell>C.C. o Nit</TableCell>
              <TableCell>Cliente</TableCell>
              <TableCell>Teléfono</TableCell>
              <TableCell>E-Mail</TableCell>
              <TableCell align="right">Saldo</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.cuenta}>
                <TableCell>{row.cuenta}</TableCell>
                <TableCell>{row.facturaNo}</TableCell>
                <TableCell>{row.doc}</TableCell>
                <TableCell>{row.nombre}</TableCell>
                <TableCell>{row.telefono}</TableCell>
                <TableCell>{row.correo}</TableCell>
                <TableCell align="right">{row.saldo}</TableCell>
                <TableCell>
                  <Button variant="contained" color="primary" className={classes.button} onClick={() => { btnAgregar(row.cuenta, props) }} >
                    Agregar</Button>

                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

      </React.Fragment>
    </Paper>
  );
};

const Cuentas = props => {
  const { classes } = props
  return (
    props.cuenta.resp === "ok" ? tabla(props, classes) : <div></div>

  );
};

const mapStateToProps = function (state) {
  return {
    cuenta: state.cuenta,
    terceroID: state.auth.terceroID,
  }
}

export default connect(mapStateToProps, { postAddCtaToTercero })(Cuentas);


//<AddCircleOutline className={clsx(classes.leftIcon, classes.iconSmall)} />